/**
 * Temporary URL
 */
export const BASIC_URL_TEMP = `${
  process.env.REACT_APP_BASIC_URL_TEMP ?? ""
}/api`;

export const BASIC_URL = `${process.env.REACT_APP_BASIC_URL ?? ""}/api`;
